import React from 'react';
import {connect} from 'react-redux';
import propTypes from 'prop-types';
import lang from '../../constants/Languages.js';
import {withRouter} from 'react-router';
import {Link} from 'react-router-dom';

import Error505Page from '../Error505Page.js';
import LoadingIndicator from '../LoadingIndicator.js';

import * as wpScripts from '../../scripts/wpObjectScripts.js';

const CollectionsAbout = ({ clang, data, isLoadingError, isFetching }) => {
    if (isLoadingError) {
        return <div className="collections-about">
                   <Error505Page />
               </div>;
    }

    if (isFetching) {
        return <div className="collections-about">
                   <LoadingIndicator />
               </div>;
    }


    if (!data) {
        return null;
    }

    const collectionItems = wpScripts.getItems(data.acf);

    return (
        <article className="collections-about">
            <h2 className="collections-about__title" dangerouslySetInnerHTML={{__html: data.acf.collections_title}}></h2>
            <p className="collections-about__desc" dangerouslySetInnerHTML={{__html: data.acf.collections_desc}}></p>
            <h2 className="collections-about__brief-title" dangerouslySetInnerHTML={{__html: lang[clang].collections.in_brief}}></h2>
            <ul className="collections-about__brief-list">
                {collectionItems.map((item, index) =>
                    <li key={index} className="collections-about__brief-item">
                        <span className="collections-about__brief-item--paperclip"></span>
                        <h3 className="collections-about__brief-item--title">{item.title}</h3>
                        <div className="collections-about__brief-item--content">
                            <img src={item.img} alt={lang[clang].alt.collection} className="collections-about__brief-item--img"/>
                            <p className="collections-about__brief-item--desc" dangerouslySetInnerHTML={{__html: item.desc}}></p>
                        </div>
                        <Link className="collections-about__button"
                         to={`/collections/about/${item.id}`}
                         title={lang[clang].collections.learn_more}>
                            {lang[clang].collections.learn_more}
                            <span className="collections-about__button-img"></span>
                        </Link>
                    </li>)}
            </ul>
        </article>
    );
};

CollectionsAbout.propTypes = {
    clang: propTypes.string.isRequired
};

const mapStateToProps = state => ({
    clang: state.language.currentLanguage
});

export default withRouter(connect(mapStateToProps)(CollectionsAbout));



// WEBPACK FOOTER //
// ./src/components/collections/CollectionsAbout.js